import { render, staticRenderFns } from "./BuscadorPage.vue?vue&type=template&id=9ac0f6a0"
import script from "./BuscadorPage.js?vue&type=script&lang=js&external"
export * from "./BuscadorPage.js?vue&type=script&lang=js&external"
import style0 from "./BuscadorPage.vue?vue&type=style&index=0&id=9ac0f6a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports